import request from '@/utils/request'

// 登录
export function login(data) {
  return request({
    url: '/hrApi/user/login',
    method: 'post',
    data: data
  })
}

// 分页查询用户信息
export function getPageList(params) {
  return request({
    url: '/hrApi/user',
    method: 'get',
    params: params
  })
}

// 查询用户列表
export function getList(params) {
  return request({
    url: '/hrApi/user/list',
    method: 'get',
    params: params
  })
}

// 新增或编辑用户
export function saveOrUpdateData(data) {
  return request({
    url: '/hrApi/user',
    method: 'post',
    data: data
  })
}

// 删除用户
export function deleteData(id) {
  return request({
    url: '/hrApi/user/' + id,
    method: 'delete'
  })
}

// 查询所有用户
export function getAll() {
  return request({
    url: '/hrApi/user/all',
    method: 'get'
  })
}

// 删除合作方
export function deleteCooperateData(id) {
  return request({
    url: '/hrApi/user/cooperate/' + id,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js